import { useRef } from "react";
import { useLanguage } from "@/context/LanguageContext";

export const FilePicker = ({ file, onChange, accept = "image/*", testid, buttonTestid, id }) => {
  const ref = useRef(null);
  const { t } = useLanguage();
  return (
    <>
      <input ref={ref} id={id} data-testid={testid} type="file" accept={accept} className="hidden" onChange={(e) => onChange(e.target.files?.[0] || null)} />
      <button type="button" data-testid={buttonTestid || (testid ? `${testid}-button` : undefined)} onClick={() => ref.current?.click()} className={`mt-1.5 w-full h-12 rounded-xl border border-input bg-transparent px-4 text-left text-sm transition-colors hover:border-accent ${file ? "text-slate-700" : "text-slate-400"}`}>
        {file ? file.name : t("photo.choose")}
      </button>
    </>
  );
};
